/** Faixa vermelha de ponta a ponta no topo do painel enquanto a mensalidade
 *  estiver vencida. Nao tem botao de fechar: some sozinha quando o aviso-visual
 *  deixa de devolver 'vencida' (fatura paga). Recebe o aviso que o Dashboard ja
 *  busca — nao faz requisicao propria. */
const brl = (v) => (Number(v) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export default function FaixaMensalidadeVencida({ aviso, naAssinatura = false, onPagar }) {
  if (!aviso || aviso.nivel !== "vencida") return null;
  const dias = Number(aviso.dias) || 0;
  const diasTxt = `${dias} dia${dias === 1 ? "" : "s"}`;
  const venc = (aviso.vencimento || "").slice(0, 5);
  return (
    <div
      role="alert"
      data-e2e="faixa-mensalidade-vencida"
      className="flex-shrink-0 w-full flex items-center justify-center gap-3 bg-red-600 text-white px-4 py-2 text-sm shadow-md"
    >
      <span className="min-w-0">
        <strong className="sm:hidden">Mensalidade vencida — {brl(aviso.valor)}</strong>
        <strong className="hidden sm:inline">
          Mensalidade vencida há {diasTxt} — {brl(aviso.valor)}
          {venc ? ` (venceu em ${venc})` : ""}
        </strong>
      </span>
      {!naAssinatura && (
        <button
          type="button"
          onClick={onPagar}
          className="flex-shrink-0 rounded-md bg-white text-red-700 font-semibold px-3 py-1 hover:opacity-90 transition-opacity"
        >
          Pagar agora
        </button>
      )}
    </div>
  );
}
